import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard, Timer } from 'lucide-react';
import { Button } from '../ui/Button';
export function FinalCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 3
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <section className="py-24 bg-wood-dark text-cream relative overflow-hidden wood-texture" data-id="element-115">
      <div className="absolute inset-0 bg-wood-dark/90 mix-blend-multiply" data-id="element-116"></div>

      <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto" data-id="element-118">
          <div className="mb-8 flex flex-col items-center justify-center" data-id="element-119">
            <div className="flex items-center text-amber mb-4" data-id="element-120">
              <Timer className="w-5 h-5 mr-2" data-id="element-121" />
              <span className="font-bold uppercase tracking-wider text-sm" data-id="element-122">
                El precio de lanzamiento cierra en:
              </span>
            </div>
            <div className="text-4xl md:text-5xl font-black text-amber font-mono tracking-widest bg-charcoal/50 px-6 py-3 rounded-xl border border-amber/20" data-id="element-123">
              {formatNumber(timeLeft.hours)}:{formatNumber(timeLeft.minutes)}:
              {formatNumber(timeLeft.seconds)}
            </div>
            <p className="text-cream/60 italic mt-3 text-sm" data-id="element-124">
              *Después sube $8.000 ARS y no vuelve.*
            </p>
          </div>

          <h2 className="text-4xl md:text-6xl font-black text-white mb-10" data-id="element-125">
            SUPER COMBO™ <br data-id="element-126" />
            <span className="text-amber" data-id="element-127">CARPINTERÍA PLEGABLE PRO</span>
          </h2>

          <p className="text-xl md:text-2xl text-cream-dark/90 mb-12 font-serif italic" data-id="element-128">
            "Porque fabricar muebles que transforman espacios no debería
            costarte todos los fines de semana del año."
          </p>

          <div className="mb-12" data-id="element-129">
            <Button href="#comprar" size="xl" className="animate-pulse-slow w-full md:w-auto text-xl" data-id="element-130">
              QUIERO MI SUPER COMBO AHORA
            </Button>
          </div>

          <div className="flex flex-col md:flex-row justify-center items-center gap-6 text-sm text-cream/80 bg-wood-medium/30 py-4 px-8 rounded-full inline-flex backdrop-blur-sm border border-wood-light/20" data-id="element-131">
            <span className="flex items-center" data-id="element-132">
              <Lock className="w-4 h-4 mr-2 text-amber" data-id="element-133" /> Pago 100% seguro
            </span>
            <span className="hidden md:inline text-wood-light" data-id="element-134">•</span>
            <span className="flex items-center" data-id="element-135">
              <ShieldCheck className="w-4 h-4 mr-2 text-amber" data-id="element-136" /> Acceso en 5
              minutos
            </span>
            <span className="hidden md:inline text-wood-light" data-id="element-137">•</span>
            <span className="flex items-center" data-id="element-138">
              <ShieldCheck className="w-4 h-4 mr-2 text-amber" data-id="element-139" /> Garantía 7
              días
            </span>
            <span className="hidden md:inline text-wood-light" data-id="element-140">•</span>
            <span className="flex items-center" data-id="element-141">
              <CreditCard className="w-4 h-4 mr-2 text-amber" data-id="element-142" /> Mercado Pago |
              Tarjeta | Transferencia
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}